export const getTwitchStreaming = state => state.syncReducer.twitch.streaming
export const getTwitchName = state => state.syncReducer.twitch.name
export const getTwitchUrl = state => state.syncReducer.twitch.url
export const getTwitchStatus = state => state.syncReducer.twitch



// WEBPACK FOOTER //
// ./src/features/Sync/data/twitch/selectors.js